// PersonalInfo expects MM/DD/YYYY; check_token / Recoil may give ISO YYYY-MM-DD.
const toMMDDYYYY = (raw) => {
  if (!raw) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  return m ? `${m[2]}/${m[3]}/${m[1]}` : raw;
};

// Shared helper so the provider's initial seed and the post-login seed can't
// diverge — both must run user.dob through toMMDDYYYY or PersonalInfo's Yup
// regex rejects the API's YYYY-MM-DD shape on a field the user never touched.
export const buildPersonalInfoSeed = (user) => ({
  f_name: user?.f_name || '',
  l_name: user?.l_name || '',
  dob: toMMDDYYYY(user?.dob),
  email: user?.email || '',
  phone: user?.phone || ''
});
